import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Width.css';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';

const WidthSnippet = () => {
  const widthSnippetRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const wCopySnippet = () => {
    if (widthSnippetRef.current) {
      const range = document.createRange();
      range.selectNode(widthSnippetRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  const hSnippetRef = useRef(null);
  const [hShowScanning, hSetShowScanning] = useState(false);

  const hCopySnippet = () => {
    if (hSnippetRef.current) {
      const range = document.createRange();
      range.selectNode(hSnippetRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      hSetShowScanning(true);
      setTimeout(() => hSetShowScanning(false), 1000);
    }
  };

  return (
    <>
      <pre>
        <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={widthSnippetRef}>
            <code>
              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-width-quarter</span><span class="cln">"</span><span class="cn">&gt;</span>width: 25%;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-width-half</span><span class="cln">"</span><span class="cn">&gt;</span>width: 50%;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-width-full</span><span class="cln">"</span><span class="cn">&gt;</span>width: 100%;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-width-auto</span><span class="cln">"</span><span class="cn">&gt;</span>width: auto;<span class="cn">&lt;/div&gt;</span>

            </code>
          </div>
          <button aria-label="Copy Button" onClick={wCopySnippet}>
            <Copy />
          </button>
        </div>
        <div className={`center-container ${hShowScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={hSnippetRef}>
            <code>
              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-height-quarter</span><span class="cln">"</span><span class="cn">&gt;</span>height: 25%;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-height-half</span><span class="cln">"</span><span class="cn">&gt;</span>height: 50%;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-height-full</span><span class="cln">"</span><span class="cn">&gt;</span>height: 100%;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-height-auto</span><span class="cln">"</span><span class="cn">&gt;</span>height: auto;<span class="cn">&lt;/div&gt;</span>

            </code>
          </div>
          <button aria-label="Copy Button" onClick={hCopySnippet}>
            <Copy />
          </button>
        </div>
      </pre>
    </>
  );
}


const Width = () => {

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Card
        CardTitle='Width & Height'
        CardBody={<WidthSnippet />}
      />
    </motion.div>
  );
}

Width.propTypes = {};

export default Width;
